import { TasksService } from 'src/app/services/tasks.service';
import { Component, inject, OnInit } from '@angular/core';
import { SettlementsService } from 'src/app/services/settlements.service';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-tenant-dashboard',
  template: `
    <div class="d-flex">
      <div class="flex-fill">
        <div class="list-group rounded-4 shadow mt-2" *ngIf="bills.length > 0">
          <tr app-item-bill
            [bill]="bill"
            [profile]="profile"
            [permissions]="permissions"
            *ngFor="let bill of bills | paginate: { itemsPerPage: payload.per_page, currentPage: p, totalItems: meta.total_entries}"
          ></tr>
        </div>
      </div>
    </div>
    <div class="d-flex">
      <div class="flex-fill">
        <div class="list-group rounded-4 shadow mt-2">
          <div class="list-group-item">
            <h2 class="mt-2">Consumos</h2>
          </div>
          <div class="list-group-item">
            <app-small-consume-line-chart></app-small-consume-line-chart>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex mb-5">
      <div class="flex-fill mb-5">
        <div class="list-group shadow mt-3 m-sm-0 rounded-4">
          <div class="list-group-item">
            <div class="row">
              <div class="col-4 col-sm-2 col-md-2 text-center">
                <img src="assets/images/building-avatar.png" width="50%">
              </div>
              <div class="col-8 col-sm-2 col-md-10">
                <h5 class="mb-0">Condominio</h5>
                <h3 class="mb-0">{{settlement?.settlement?.name}}</h3>
                <p class="mb-0">{{settlement?.settlement?.address}} {{settlement?.settlement?.city}} {{settlement?.settlement?.state}} </p>
                <h5 class="mb-0 mt-3">Edificio</h5>
                <h3 class="mb-3">{{settlement?.building?.name}}</h3>
                <h5 class="mb-0">Departamento</h5>
                <h3 class="mb-3">{{settlement?.unit?.name}}</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: []
})
export class TenantDashboardComponent implements OnInit {
  bills: any = [];
  meta: any = {};

  userLS: any = {};
  tenant: any = null;
  settlement: any = {};
  tasks: any = [];

  profile: any = {};
  permissions: any = {};

  loading: boolean = false;

  payload: any = {    
    page: 1,
    per_page: 50,
    status: false,
    state: [1]
  };

  p: number = 1;
  storageService = inject(StorageService);
  constructor(
    private store: SettlementsService,
    private tasksService: TasksService
  ) {
    this.userLS = this.storageService.getItem(STORAGE_KEYS.USER) ?? {};
    this.profile = this.storageService.getItem(STORAGE_KEYS.PROFILE) ? this.storageService.getItem(STORAGE_KEYS.PROFILE).profile : null;
    this.permissions = this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) ? this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) : null;
  }

  ngOnInit(): void {
    this.store.getTenant(this.userLS.id).subscribe((tenant: any) => {
      this.tenant = tenant;
      this.store.getUnitSettlement(tenant.unit_id).subscribe((settlement: any) => {
        this.settlement = settlement;
        this.storageService.saveItem(STORAGE_KEYS.SETTLEMENT, settlement);
      });
      this.tasksService.getTasks({ unit_id: tenant.unit_id, status: 1 }).subscribe((tasks: any) => {
        this.tasks = tasks.data;
      });

      this.store.getBillsByUnits(this.tenant?.id, this.payload).subscribe({
        next: (bills: any) => {
          console.log(bills);
          if (bills.length === 0) {
            this.bills = [];
            this.meta = {};
            this.loading = false;
            return;
          }
          this.bills = bills.data;
          this.meta = bills.meta;
          this.loading = false;
        },
        error: (error: any) => {
          this.bills = [];
          this.loading = false;
        }
      });
    });
    
  }
}
